import { useContext } from "react";
import SectionNavigationContext from "./section-navigation-context";
import { SectionNavigationContextType } from "./interfaces";

// TODO: use new asserts syntax when Typescript will be updated
const isContextPresent = (
  context: Partial<SectionNavigationContextType>,
): context is SectionNavigationContextType => Object.keys(context).length !== 0;

const useSectionNavigationContext = () => {
  const context = useContext(SectionNavigationContext);

  if (!isContextPresent(context)) {
    throw new Error(
      "SectionNavigation compound components cannot be rendered outside the SectionNavigation component",
    );
  }

  return context;
};

export default useSectionNavigationContext;
